import React from 'react';
import { formatCurrency } from '../../lib/utils';

const fmt = (val, key) => {
  if (val === null || val === undefined || val === '') return '—';
  if (key.toLowerCase().includes('price') || key.toLowerCase().includes('rate') || key.toLowerCase().includes('total') || key.toLowerCase().includes('amount')) {
    return typeof val === 'number' ? formatCurrency(val) : val;
  }
  return String(val);
};

export const HistoryTable = ({ columns, rows, emptyLabel, testId }) => {
  if (!rows || rows.length === 0) {
    return <div className="py-8 text-center text-sm text-muted-foreground" data-testid={testId ? `${testId}-empty` : undefined}>{emptyLabel || 'No records found'}</div>;
  }
  return (
    <div className="border rounded-sm max-h-[320px] overflow-y-auto" data-testid={testId}>
      <table className="w-full text-xs">
        <thead className="sticky top-0 bg-muted/80 backdrop-blur-sm">
          <tr>
            {columns.map(c => (
              <th key={c.key} className="text-left font-medium uppercase text-muted-foreground px-2 py-1.5 whitespace-nowrap">{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className="border-t hover:bg-muted/30" data-testid={testId ? `${testId}-row-${i}` : undefined}>
              {columns.map(c => (
                <td key={c.key} className="px-2 py-1.5 whitespace-nowrap max-w-[220px] truncate">{fmt(row[c.key], c.key)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
